import React from 'react';
import Button from '@mui/material/Button';
import { defaultColors } from '../../ColorSchema';

function PrimaryButton({ ...props }) {
    return (
        <Button
            {...props}
            sx={{

                textTransform: 'none',
                backgroundColor: defaultColors.primary,
                color: defaultColors.on_primary,
                whiteSpace: 'nowrap',
                height: '40px',
                '&:hover': {
                    backgroundColor: defaultColors.secondary,
                    color: defaultColors.on_secondary,
                },
                // disabled styles
                '&.Mui-disabled': {
                    backgroundColor: defaultColors.disabled_surface,
                    color: defaultColors.on_disabled_surface,
                },
                // if you also want to prevent hover from changing disabled styles:
                '&.Mui-disabled:hover': {
                    backgroundColor: defaultColors.disabled_surface,
                    color: defaultColors.on_disabled_surface,
                },
            }}
        >
            {props.children}
        </Button>
    );
}

export default PrimaryButton;
